define('components/factory/views/MultiMediasView', [
    'components/factory/templates/multimediasview'
], function(tpl) {

    var MultiMediasView = Mazarine.View.extend({

        events: {
        },

        template: tpl,

        className: "maz-multimedias-view",

        itemViews: [],

        nbMediasReady: 0,
        mediasTotal: 0,

        videoProductCount: 0,
        videoCount: 0,
        productCount: 0,
        shareCount: 0,
        shareImageCount: 0,

        videosPosition: [],

        initialize: function(options) {
            Mazarine.View.prototype.initialize.call(this);

            this.Factory = options.factory;
            this.itemViews = [];
        },

        afterRender: function() {
            this.videoProductCount = 0;
            this.videoCount = 0;
            this.productCount = 0;
            this.shareCount = 0;
            this.shareImageCount = 0;
            this.nbMediasReady = 0;
            this.mediasTotal = 0;

            var preloadImages = [];

            _.each( this.model.get("mediasGroup"), function( item, index ) {
                _.each( item.medias, function( media, index ){
                    if( media.videoproduct || media.video || media.product || media.share || media.image || ( media.image && media.image.share ) ) {
                        this.mediasTotal++;
                    }
                    if( media.image ){
                        preloadImages.push( this.model.get('assets_url') + media.image.src );
                    }
                }, this);
            }, this);

            this.loadImages( preloadImages );
            if( this.mediasTotal === 0 ){
                this.model.set('isReady', true);
            }

            _.each( this.model.get("mediasGroup"), function( item, index ) {
                _.each( item.medias, function( media, index ){
                    var obj = {};

                    var itemModel = null,
                        itemView = null;

                    var $selector = null;

                    if( media.videoproduct ){
                        obj = _.extend( {
                            "type": "videoproductview",
                            "viewId": "videoproduct-view-" + media.videoproduct.video.type
                        }, media.videoproduct );

                        obj.onPlayMultimediasVideo = _.bind( this.onPlayMultimediasVideo, this );

                        $selector = this.$('.maz-multimedias-video-product-wrapper').eq( this.videoProductCount );
                        this.videoProductCount++;
                    }else if( media.video ){
                        obj = _.extend( {
                            "type": "videoview",
                            "viewId": "video-view-" + media.video.video.type
                        }, media.video );

                        obj.onPlayMultimediasVideo = _.bind( this.onPlayMultimediasVideo, this );

                        $selector = this.$('.maz-multimedias-video-wrapper').eq( this.videoCount );
                        this.videoCount++;
                    }else if( media.product ){
                        obj = _.extend( {
                            "type": "productview",
                            "viewId": "product-view-" + media.product.codeY
                        }, media.product);

                        $selector = this.$('.maz-multimedias-product-wrapper').eq( this.productCount );
                        this.productCount++;
                    }else if( media.share ){
                        obj = _.extend({
                            "type": "shareview",
                            "viewId": "share-view-" + this.shareCount
                        }, media.share);

                        $selector = this.$('.maz-multimedias-share-wrapper').eq( this.shareCount );
                        this.shareCount++;
                    }else if( media.image && media.image.share ){
                        obj = _.extend({
                            "type": "shareview",
                            "viewId": "share-image-view-" + this.shareImageCount
                        }, media.image.share);

                        $selector = this.$('.maz-multimedias-share-image-wrapper').eq( this.shareImageCount );
                        this.shareImageCount++;
                    }

                    if( !_.isEmpty(obj) ){
                        itemModel = this.Factory.createModelFromData(obj);
                        this.listenTo( itemModel, "change:isReady", _.bind( this.onMediaReady, this ) );
                        itemView = this.Factory.createViewFromModel(itemModel);

                        $selector.html( itemView.render().$el );
                        if( itemView.afterRender ){
                            itemView.afterRender();
                        }

                        this.itemViews.push( itemView );
                    }

                }, this);
            }, this);
        },

        onMediaReady: function( model, isReady ) {
            this.nbMediasReady++;

            if( model && model.get('error') ) {
                _.filter( this.itemViews, function( v ) { return v.model.cid === model.cid; } )[0].$el.parents('.maz-media').addClass('maz-media-error');
            }

            if( this.nbMediasReady === this.mediasTotal ){

                this.videosPosition = [];

                _.each( this.model.get('mediasGroup'), function( item, index ) {
                    if( item.slick ) {
                        this.$('.maz-media-block').eq( index ).find('.maz-slick-wrapper').slick( item.slick );
                    }
                }, this);

                _.each( this.itemViews, function( itemView, index ){
                    if( itemView.model.get('type') === 'videoview' ) {
                        this.videosPosition.push( {
                            mediaIndex: index,
                            top: itemView.$el.offset().top,
                            bottom: itemView.$el.offset().top + itemView.$el.height()
                        } );
                    }
                }, this );

                this.model.set('isReady', true);
            }
        },

        onRemove: function() {
            _.each( this.itemViews, function( item, index ){
                if(typeof item.onRemove === "function") {
                    item.onRemove();
                }
            });
        },

        progress: function(img, nbImagesPreloaded, nbImagesToPreload, finished) {
            this.onMediaReady();
        },

        onPlayMultimediasVideo: function( video ) {
            _.each( this.itemViews, function( itemView ) {
                if( itemView.cid !== video.cid && itemView.pause ) {
                    itemView.pause();
                }
            }, this );
        },

        onScroll: function( scrollTop ) {
            if( this.model.get('autoplayVideoOnScroll') && !$("html").hasClass('mmm-is-fullscreen')) {
                _.each( this.videosPosition, function( pos ) {
                    if( scrollTop < pos.top && scrollTop + $( window ).height() > pos.bottom ) {
                        this.itemViews[ pos.mediaIndex ].play();
                    } else {
                        this.itemViews[ pos.mediaIndex ].pause();
                    }
                }, this );
            }
        }
    });

    return MultiMediasView;
});
